import React from 'react';
import { Grid } from '@mui/material';
import { Colors, Text } from 'library';
import { formatMonthDayYear } from 'shared/Dates';

interface IPayMethod {
    id: number;
    added_at: string;
    is_default: boolean;
    account_type: string;
    last_four: string;
    cardholder_name?: string | null;
    exp_month?: number | null;
    exp_year?: number | null;
    errorMessage: string;
    isLoading: boolean;
}

interface PayMethodProps {
    payMethod: IPayMethod;
}

export default function PayMethod({ payMethod }: PayMethodProps) {
    const expiry =
        payMethod.exp_month && payMethod.exp_year
            ? `Expires ${String(payMethod.exp_month).padStart(2, '0')}/${payMethod.exp_year}`
            : '';
    const detailParts = [payMethod.cardholder_name, expiry].filter(Boolean);

    return (
        <Grid xs={12} md={6} item alignItems="center" justifyContent={'flex-start'}>
            <Text variant="body1">
                {payMethod.account_type} •••• {payMethod.last_four}
            </Text>
            {detailParts.length > 0 && <Text variant="caption">{detailParts.join(' · ')}</Text>}
            <Text variant="caption">Added: {formatMonthDayYear(payMethod.added_at)}</Text>
            {payMethod.errorMessage ? (
                <Text variant="body1" color={Colors.terraCotta} bold>
                    {payMethod.errorMessage}
                </Text>
            ) : null}
        </Grid>
    );
}
